import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { heroData } from '../../data/mock';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-black flex items-center pt-20">
      {/* Grid Pattern Overlay */}
      <div 
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 7.6923%),
            repeating-linear-gradient(-90deg, #fff, #fff 1px, transparent 1px, transparent 7.6923%)
          `,
          backgroundSize: '100% 100%'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#00FFD1]/30 mb-8">
            <ShieldCheck className="w-5 h-5 text-[#00FFD1]" />
            <span className="text-[#00FFD1] text-sm font-medium tracking-wide uppercase">
              Florida Licensed & Insured
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-[66px] font-semibold text-white leading-[1.1] tracking-[-0.62px] mb-6">
            {heroData.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-white/85 leading-relaxed mb-10 max-w-2xl">
            {heroData.subheadline}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              className="bg-[#00FFD1] text-black hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] rounded-none px-8 py-6 text-lg font-medium transition-all duration-400 flex items-center justify-between gap-3 min-h-[56px]"
            >
              {heroData.primaryCta}
              <ArrowRight className="w-5 h-5" />
            </Button>
            <Button
              variant="outline"
              className="bg-white/10 text-white border-0 hover:bg-white hover:text-black rounded-none px-8 py-6 text-lg font-medium transition-all duration-400 flex items-center justify-between gap-3 min-h-[56px]"
            >
              {heroData.secondaryCta}
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mt-16 pt-16 border-t border-white/10">
            <div>
              <p className="text-3xl sm:text-4xl font-semibold text-[#00FFD1]">500+</p>
              <p className="text-white/60 mt-1">Active Officers</p>
            </div>
            <div>
              <p className="text-3xl sm:text-4xl font-semibold text-[#00FFD1]">15+</p>
              <p className="text-white/60 mt-1">Years Experience</p>
            </div>
            <div>
              <p className="text-3xl sm:text-4xl font-semibold text-[#00FFD1]">12</p>
              <p className="text-white/60 mt-1">Florida Cities</p>
            </div>
            <div>
              <p className="text-3xl sm:text-4xl font-semibold text-[#00FFD1]">24/7</p>
              <p className="text-white/60 mt-1">Availability</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
